import React from 'react';

interface ContentSectionProps {
  title: string;
  content: string;
  imageUrl?: string;
  imageAlt?: string;
  reverse?: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({ 
  title, 
  content, 
  imageUrl, 
  imageAlt = "Section image",
  reverse = false 
}) => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-12`}>
          <div className="w-full md:w-1/2">
            <h2 className="text-3xl font-bold mb-6 text-gray-800">{title}</h2>
            <div className="prose prose-lg max-w-none text-gray-600">
              {content.split("\\n\\n").map((paragraph, idx) => (
                <p key={idx} className="mb-4">{paragraph}</p>
              ))}
            </div>
          </div>
          
          {imageUrl && (
            <div className="w-full md:w-1/2">
              <img 
                src={imageUrl} 
                alt={imageAlt} 
                className="rounded-lg shadow-md w-full h-auto object-cover"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
